import React from 'react';
import { RadioButtonList } from './RadioButtonList';
import { UseFormRegister } from 'react-hook-form';
import { BankAccountFormData } from '@js/interfaces';

type Props = {
  setRouteNum: React.Dispatch<React.SetStateAction<number>>
  onUpdateBankAccount: (key: 'bank_id' | 'branch_id', value: string) => void
  branch_list: {
    id: number
    code: string
    name: string
    name_hira: string
  }[],
  routeNumList: {
    bankInitials: number
    bankSelect: number
    branchInitials: number
    branchSelect: number
  },
  register: UseFormRegister<BankAccountFormData>
  watchRadioButtonBranch: string
  errors: { [name: string]: object | undefined }
};

export const BranchNameSelect = (props: Props) => {
  const { routeNumList, setRouteNum, branch_list, register, watchRadioButtonBranch, onUpdateBankAccount, errors } = props;
  const fieldLabel = 'branch';

  return (
    <div className="bank-account">
      <div className="bank-account__heading">
        支店の選択
      </div>
      <div className="bank-account__lead">
        支店名を選択してください。
      </div>
      {branch_list.length > 0 ? (
        <ul className="bank-account__list">
          {branch_list ? (
            <RadioButtonList selectList={branch_list} fieldLabel={fieldLabel} register={register} errors={errors} />
          ) : (
            <div className="loader" />
          )}
        </ul>
      ):(
        <div className="bank-account__list">
          <p className="bank-account__list-message">
            当てはまる支店名がありません
          </p>
        </div>
      )}
      <div className="layout-flex--center bank-account__button-layout">
        <div className="is-pc">
          <button onClick={() => setRouteNum(routeNumList.branchInitials)} className="button-base--sub button-w182 mr16">
            前の入力へ戻る
          </button>
        </div>
        <button onClick={() => onUpdateBankAccount('branch_id', watchRadioButtonBranch)} type="button" className="button-base--action button-w344">
          決定する
          <i className="material-icons button-icon-right flip-horizontal">keyboard_backspace</i>
        </button>
      </div>
    </div>
  );
};
